<template>
  <div class="">
    <div class="d-flex flex-column align-center mt-4">
      <v-icon large style="transform: rotate(-45deg)">mdi-key-outline</v-icon>
    </div>

    <div class="d-flex flex-column align-center mt-6">
      <div class="text-h6">Forget password?</div>
      <div class="">No worries, we'll send you reset instructions.</div>
    </div>

    <v-form lazy-validation ref="form" class="mt-10">
      <v-text-field
        v-model="form.email"
        @keyup.enter="sendedLink"
        :rules="[$rules.required, $rules.email]"
        :disabled="loading"
        type="email"
        placeholder="you@company.com"
        prepend-inner-icon="mdi-email-outline"
        class="rounded-lg"
        height="48px"
        outlined
      ></v-text-field>

      <v-btn
        @click="sendedLink"
        :loading="loading"
        color="primary"
        class="rounded-lg font-weight-bold"
        height="48px"
        block
      >
        Reset Password
      </v-btn>

      <div class="mt-4 text-center font-weight-bold" v-if="sent">
        Didn't receive the email?
        <span @click="sendedLink" class="primary--text pointer">
          Click to resend
        </span>
      </div>

      <v-btn
        @click="navigateToLoginRoute"
        class="rounded-lg mt-4 font-weight-bold text-none"
        height="48px"
        block
        text
      >
        <v-icon left>mdi-arrow-left</v-icon>
        Back to log in
      </v-btn>
    </v-form>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      sent: false,
      loading: false,
      form: {
        email: "",
      },
    };
  },

  methods: {
    ...mapActions({
      showSnackbar: "app/showSnackbar",
    }),

    sendedLink() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        const onSuccess = (res) => {
          const resData = res.data;

          this.sent = true;
          this.showSnackbar({ text: resData.message, color: "success" });
        };

        const onFinally = () => {
          this.loading = false;
        };

        const data = {};
        data["email"] = this.form.email;

        return this.$request(
          this.$keys.POST,
          this.$urls.auth.passwordGenerateLink,
          {
            data,
            onSuccess,
            onFinally,
            isTokenRequired: false,
          }
        );
      }
    },

    navigateToLoginRoute() {
      this.$router.push({ name: "login" });
    },
  },
};
</script>
